import css from 'styled-jsx/css'

export const ContactStyle = css.global`
  .contact-page {
    text-align: center;
    background-color: #fff;
    min-height: calc(100vh - 64px);
  }

  .contact-page .contact-wrapper {
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
  }
  .footer-background {
    background-position: top center;
    background-repeat: no-repeat;
  }
  .chat-with-support-btn {
    background: white;
    color: var(--primary);
    padding: 12px 32px;
    font-size: 16px;
    border-radius: 4px;
    font-weight: 500;
  }
  .footer-text {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    line-height: 1.33;
  }
  .contact-page
    .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)
    .ant-select-selection-search-input {
    height: 40px;
  }
  /* .contact-page .contact-background {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, -80%);
  }

  .contact-page .contact-background img {
    width: 100%;
  } */

  .contact-page .title {
    font-size: 36px;
    line-height: 44px;
    font-weight: 700;
    padding-top: 40px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  .contact-page .sub-title {
    color: #595959;
    font-size: 18px;
    line-height: 26px;
    white-space: break-spaces;
  }

  .contact-page .contact-form {
    width: 640px;
    margin: 0 auto;
    padding: 32px 24px;
    background-color: #fff;
    box-shadow: 0 8px 40px 0 rgba(16, 120, 255, 0.1);
    border-radius: 20px;
    text-align: left;
  }

  .contact-page .contact-form .form-title {
    font-size: 20px;
    line-height: 28px;
    font-weight: bold;
    text-align: center;
    max-width: 391px;
    margin: 0 auto 32px;
  }

  .contact-page .high-light {
    color: var(--primary);
  }

  .contact-page .contact-form .btn-submit {
    border-radius: 5px;
  }

  .contact-page .contact-form .contact-success {
    text-align: center;
  }

  .contact-page .contact-form .contact-success .icon {
    font-size: 60px;
    margin-bottom: 30px;
  }

  .contact-page .contact-form .contact-success .text {
    font-size: 20px;
    line-height: 28px;
    color: #595959;
    white-space: break-spaces;
  }

  .contact-page .contact-form .contact-success .text .high-light {
    font-size: 30px;
    font-weight: bold;
  }

  .contact-page .footer_contact {
    font-size: 24px;
    line-height: 32px;
    padding: 40px 0;
    white-space: break-spaces;
    color: #595959;
  }

  .contact-page .footer_contact strong {
    color: #262626;
  }

  .ant-col.ant-form-item-label {
    padding-bottom: 2px;
  }

  .ant-input {
    font-size: 14px !important;
    padding: 8px 11px !important;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    font-size: 14px !important;
    padding-top: 5px;
    padding-bottom: 5px;
    height: 40px;
  }

  #employee_contact_submit {
    margin-top: 8px;
    height: 48px;
  }

  .ant-form-vertical .ant-form-item {
    margin-bottom: 16px;
  }
  @media screen and (min-width: 700px) {
    .md\:left-\[310px\]-mtop\[116px\] {
      left: 310px;
      top: 116px;
    }
  }
  @media screen and (max-width: 700px) {
    .contact-page .contact-form {
      max-width: 640px;
      width: 100%;
    }

    .contact-page .title {
      padding-top: 30px;
      font-size: 32px;
    }

    .contact-page .sub-title {
      font-size: 18px;
    }
  }
`
